import { LinkPaymentStatus } from "../Models/LinkPaymentStatus";

export type PaymentFrameCallbacks = {
    onBackTriggered?: () => void;
    onFinish?: (status: LinkPaymentStatus) => void;
};

const registry = new Map<string, PaymentFrameCallbacks>();

export function registerPaymentFrameCallbacks(id: string, callbacks: PaymentFrameCallbacks): void {
    registry.set(id, callbacks);
}

export function getPaymentFrameCallbacks(id: string | undefined): PaymentFrameCallbacks | undefined {
    if (!id) {
        return undefined;
    }
    return registry.get(id);
}

export function clearPaymentFrameCallbacks(id: string | undefined): void {
    if (id) {
        registry.delete(id);
    }
}
